import { styled } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { Tooltip } from "../../../../shared/components/common/Tooltip/Tooltip";

import CrossedEyeSvg from "./crossed-eye.svg?react";
import EyeSvg from "./eye.svg?react";

const ICON_SIZE = "20px";

const VisibilityToggle = ({
  "data-testid": dataTestId,
  isVisible,
  onClick,
}: {
  isVisible: boolean;
  onClick: (e: React.MouseEvent) => void;
  "data-testid"?: string;
}) => (
  <Tooltip
    title={
      isVisible ? (
        <FormattedMessage id="common.hide" />
      ) : (
        <FormattedMessage id="common.show" />
      )
    }
  >
    <StyledButton
      data-testid={dataTestId}
      onClick={onClick}
      onMouseDown={(e) => e.preventDefault()}
      type="button"
    >
      {isVisible ? <EyeSvg /> : <CrossedEyeSvg />}
    </StyledButton>
  </Tooltip>
);

const StyledButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "transparent",
  border: "none",
  padding: 0,
  lineHeight: 0,
  cursor: "pointer",
  "& svg": {
    display: "block",
    height: ICON_SIZE,
    width: ICON_SIZE,
  },
  "& svg path": {
    fill: "currentColor",
  },
  "&:not([disabled]):hover": {
    "& svg path": {
      fill: theme.palette.secondary.main,
    },
  },
}));

export { VisibilityToggle };
